import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import forwardRef from 'react-context-toolbox/forwardRef';

import styles from './FormControl.module.scss';

const propTypes = {
  /** The visual style of the input */
  theme: PropTypes.oneOf(['primary', 'secondary']).isRequired,

  /** Visually style the control as invalid */
  invalid: PropTypes.bool,
  as: PropTypes.any,
};
const defaultProps = {
  theme: 'primary',
  as: 'input',
};

function FormControl(
  { as: Input, className, theme, value, invalid, ...props },
  ref,
) {
  return (
    <Input
      {...props}
      ref={ref}
      value={value === null ? '' : value}
      className={classNames(
        className,
        styles.formControl,
        styles[theme],
        invalid && styles.invalid,
      )}
    />
  );
}

export default forwardRef(FormControl, {
  propTypes,
  defaultProps,
});
